import { Circle, geoJSON, Marker } from 'leaflet';
import { createSelector } from '@reduxjs/toolkit';
import memoizeOne from 'memoize-one';
export function findGeozoneFromId(geozones, id) {
    return geozones.find((geozone) => geozone._id === id);
}
export function getPropertiesFromGeozone(geozone) {
    return {
        name: geozone.geojson.properties?.name,
        description: geozone.geojson.properties?.description,
        color: geozone.geojson.properties?.style.color,
        notifiable: geozone.geojson.properties?.notifiable,
        overspeed: geozone.geojson.properties?.OverSpeed,
        speed: geozone.geojson.properties?.speed,
        overspeed_notification: geozone.geojson.properties?.overspeed_notification,
        id: geozone._id,
        type: geozone.geojson.geometry.type,
    };
}
export function getGeozoneIdFromFeature(feature) {
    return feature.id ? feature.id.toString() : '';
}
export const convertCoordinateToLatLngLiteral = (coordinate) => {
    if (typeof coordinate[0] === 'number' && typeof coordinate[1] === 'number') {
        return { lng: coordinate[0], lat: coordinate[1] };
    }
    return { lng: 0, lat: 0 };
};
export const convertCoordinatesToLatLngLiteralArray = (coordinates) => {
    if (typeof coordinates[0] === 'number') {
        // @ts-ignore
        return [convertCoordinateToLatLngLiteral(coordinates)];
    }
    return coordinates.flatMap(
    // @ts-ignore
    (coordinate) => {
        const len = coordinate.length;
        //Если полигон
        if (len === 1) {
            // @ts-ignore
            return convertCoordinatesToLatLngLiteralArray(coordinate);
        }
        // @ts-ignore
        return coordinate.flatMap((arr) => {
            // @ts-ignore
            return convertCoordinateToLatLngLiteral(arr);
        });
    });
};
export function calcGeozoneGeoBounds(type, coordinates, radius = null) {
    let x_min = null, x_max = null, y_min = null, y_max = null;
    const polygon_coord = coordinates[0];
    let r = 0, //градусы широты
    r_d = 0; //градусы долготы
    if (radius != null) {
        //Нужно получить длину радиуса в градусах
        if (typeof coordinates[0] === 'number')
            r = 0.1113 * Math.cos(coordinates[0]);
        r_d = radius / 111134;
    }
    switch (type) {
        case 'LineString':
            for (let i = 0; i < coordinates.length; i++) {
                // @ts-ignore
                const loc = coordinates[i];
                if (x_min == null || loc[0] < x_min)
                    x_min = loc[0];
                if (x_max == null || loc[0] > x_max)
                    x_max = loc[0];
                if (y_min == null || loc[1] < y_min)
                    y_min = loc[1];
                if (y_max == null || loc[1] > y_max)
                    y_max = loc[1];
            }
            if (x_min == null)
                return null;
            if (x_max == null)
                return null;
            if (y_min == null)
                return null;
            if (y_max == null)
                return null;
            return [
                [x_min, y_min],
                [x_max, y_max],
            ];
        case 'Point':
            if (typeof coordinates[0] === 'number' &&
                typeof coordinates[1] === 'number') {
                x_min = coordinates[0] - r;
                x_max = coordinates[0] + r;
                y_min = coordinates[1] - r_d;
                y_max = coordinates[1] + r_d;
                return [
                    [x_min, y_min],
                    [x_max, y_max],
                ];
            }
            return null;
        // break;
        case 'Polygon':
            if (typeof polygon_coord != 'number') {
                for (let i = 0; i < polygon_coord.length; i++) {
                    const loc = polygon_coord[i];
                    if (x_min == null || loc[0] < x_min)
                        x_min = loc[0];
                    if (x_max == null || loc[0] > x_max)
                        x_max = loc[0];
                    if (y_min == null || loc[1] < y_min)
                        y_min = loc[1];
                    if (y_max == null || loc[1] > y_max)
                        y_max = loc[1];
                }
                if (x_min == null)
                    return null;
                if (x_max == null)
                    return null;
                if (y_min == null)
                    return null;
                if (y_max == null)
                    return null;
                return [
                    [x_min, y_min],
                    [x_max, y_max],
                ];
            }
            break;
        default:
            return null;
    }
    return null;
}
const createGeoJSONArrayFromReduxGeozones = memoizeOne((geozones_from_redux) => geozones_from_redux.map((redux_geozone) => {
    //Вынимаем GeoJSON из Redux
    const geojson = redux_geozone.geojson;
    //Подкладываем ему id
    geojson.id = redux_geozone._id;
    return geojson;
}));
const createLayerFromGeozones = memoizeOne((geozones) => {
    const layers = [];
    geozones.forEach((feature) => {
        geoJSON(feature, {
            style: feature.properties ? { ...feature.properties.style } : {},
            pointToLayer(feature, latlng) {
                if (feature.properties.radius)
                    return new Circle(latlng, {
                        radius: feature.properties.radius,
                    });
                else {
                    return new Marker(latlng);
                }
            },
            onEachFeature(feature, layer) {
                layers.push(layer);
            },
        });
    });
    return layers;
});
export const select_geozone_layers = createSelector((state) => state.geozones ?? [], (geozones) => createLayerFromGeozones(createGeoJSONArrayFromReduxGeozones(geozones)));
